export const PLACEHOLDER_AVATAR =
    "data:image/svg+xml;utf8," +
    encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 40 40"><rect width="40" height="40" fill="#e9ecef"/><path fill="#6c757d" transform="translate(8,8)" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>'
    )

export const TABLE_PLACEHOLDER_AVATAR =
    "data:image/svg+xml;utf8," +
    encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 40 40"><rect width="40" height="40" fill="#e9ecef"/><path fill="#6c757d" transform="translate(8,8)" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>'
    )

export const PLACEHOLDER_CAMERA =
    "data:image/svg+xml;utf8," +
    encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 40 40"><rect width="40" height="40" fill="#e9ecef"/><path fill="#6c757d" transform="translate(8,8)" d="M12 3.2L9 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-5l-3-2.8zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>'
    )

export const PROFILE_TABS = [
    "Resumo",
    "Perfil",
    "Matrículas",
    "Financeiro",
    "Contratos",
    "Avaliação",
    "Testes",
    "Presenças",
]

export const CONTRACT_ACTION_TABS = ["Dados", "Suspender", "Adicionar dias", "Debitar dias", "Cancelar", "Transferir"]
